document.addEventListener('DOMContentLoaded', function () {

  /* 成分分析表画像がないページでは何もしない */
  if (!document.querySelector('[data-analysis-image]')) return;


  /* =========================================
     MODAL CREATE
  ========================================= */

  const modal = document.createElement('div');

  modal.className = 'hct-analysis-modal';

  modal.innerHTML = `
    <div
      class="hct-analysis-modal__inner"
      role="dialog"
      aria-modal="true"
      aria-label="成分分析表"
    >

      <div class="hct-analysis-modal__header">

        <p class="hct-analysis-modal__title">
          CERTIFICATE OF ANALYSIS
        </p>

        <button
          type="button"
          class="hct-analysis-modal__close"
          aria-label="閉じる"
        >
          ×
        </button>

      </div>

      <div class="hct-analysis-modal__body">

        <img
          class="hct-analysis-modal__image"
          src=""
          alt="成分分析表"
        >

      </div>

    </div>
  `;

  document.body.appendChild(modal);


  /* =========================================
     ELEMENTS
  ========================================= */

  const image = modal.querySelector('.hct-analysis-modal__image');
  const closeButton = modal.querySelector('.hct-analysis-modal__close');


  /* =========================================
     OPEN
  ========================================= */

  document.addEventListener('click', function (event) {

    const button = event.target.closest('[data-analysis-image]');

    if (!button) return;

    const imageUrl = button.dataset.analysisImage;

    if (!imageUrl) return;

    image.src = imageUrl;

    modal.classList.add('is-open');

    document.body.style.overflow = 'hidden';

  });


  /* =========================================
     CLOSE
  ========================================= */

  function closeModal() {

    modal.classList.remove('is-open');

    image.src = '';

    document.body.style.overflow = '';

  }


  /* ×ボタン */

  closeButton.addEventListener('click', closeModal);


  /* 背景クリック */

  modal.addEventListener('click', function (event) {

    if (event.target === modal) {
      closeModal();
    }

  });


  /* ESCキー */

  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      modal.classList.contains('is-open')
    ) {
      closeModal();
    }

  });

});